import request from '@/request/index'

// 获取产品中心菜单数据
export function getProductMenu(params) {
  return request.get('/pcenter/menu', params, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}


//获取菜单项 /pcenter/menus
export function getMenus(params) {
  return request.get('/pcenter/menus', params, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

//动态菜单获取 /admin/pcenter/routes
export function getRoutes(params) {
  return request.get('/pcenter/routes', params, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

//获取产品类型属于生物名单列表 /anon/enzyme
export function getEnzyme(params) {
  return request.get('/anon/enzyme', params, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}